import React from 'react';
import { useNavigate } from 'react-router-dom';
import AnnouncementsPage from './AnnouncementsPage';

const AnnouncementsPageWrapper: React.FC = () => {
  const navigate = useNavigate();
  
  return <AnnouncementsPage navigate={navigate} />;
};

export default AnnouncementsPageWrapper;
